<template>
  <v-card class="mt-4">
    <edit-offer-form
      :is-active.sync="isEditing"
      :offer="offer"
      @changed="offerUpdated"
      method="put"
    />
    <v-toolbar color="grey lighten-4" light tile flat>
      <v-toolbar-title centered class="headline font-weight-bold">
        Offer details
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <strong>Name: </strong> {{ offer.name }}
      <v-spacer></v-spacer>
      <div class="flex-grow-1"></div>
      <strong>Fee Type:</strong>{{ offer.fee_type.name }}
      <div class="flex-grow-1"></div>
      <strong>Fee Configuration:</strong>{{ offer.fee_configuration.name }}

      <v-spacer></v-spacer>
      <div class="flex-grow-1"></div>
      <v-btn color="primary" @click="updateOffer">
        <v-icon color="light-blue lighten-4">mdi-sync</v-icon>
        Edit this offer
      </v-btn>

      <div class="flex-grow-1"></div>
      <v-btn color="danger" @click="deleteOffer">
        <v-icon color="danger lighten-4">mdi-delete</v-icon>
        Delete this offer
      </v-btn>
    </v-toolbar>

    <!-- info -->
    <v-divider />
  </v-card>
</template>
<script>
import editOfferForm from "./form";
export default {
  components: {
    editOfferForm,
  },
  props: {
    offer: {
      required: true,
    },
  },
  data: () => ({
    isEditing: false,
  }),
  methods: {
    updateOffer() {
      this.isEditing = true;
    },
    offerUpdated(data) {
      this.$emit("updated", data);
      this.isEditing = false;
    },
    deleteOffer() {
      const id = this.offer.id;
      Notify.confirm(`DO you want to archive this offer?`).then(() => {
        this.$http
          .delete(`/api/v1/offers/${id}`)
          .then((result) => {
            Notify.success(result.message);
            this.$router.push({
              name: "deposits.offers.index",
              params: { id: this.$route.params.feeConfigurationId },
            });
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
  },
};
</script>
